export enum NotificationCategory {
  EARNINGS = "EARNINGS",
  MESSAGES = "MESSAGES",
  PROMOTION = "PROMOTION",
  SOCIAL = "SOCIAL",
  POST = "POST",
  MONEY = "MONEY",
}

export enum NotificationSubCategory {
  REFERRAL = "REFERRAL",
  PAID_MESSAGE = "PAID_MESSAGE",
  NEW_SUBSCRIPTION = "NEW_SUBSCRIPTION",
  UNLOCKABLE_CONTENT = "UNLOCKABLE_CONTENT",
  COIN_PURCHASE = "COIN_PURCHASE",
  COIN_SALE = "COIN_SALE",
  RECEIVED_DESO = "RECEIVED_DESO",
  RECEIVED_FOCUS = "RECEIVED_FOCUS",
  RECEIVED_DUSDC = "RECEIVED_DUSDC",
  RECEIVED_POST_TO_EARN = "RECEIVED_POST_TO_EARN",
  UNPAID_MESSAGE = "UNPAID_MESSAGE",
  ADDED_GROUP_CHAT = "ADDED_GROUP_CHAT",
  PROMOTION_OFFER = "PROMOTION_OFFER",
  PROMOTION_PERFORMANCE = "PROMOTION_PERFORMANCE",
  FOLLOW = "FOLLOW",
  MENTION = "MENTION",
  POST_TIP = "POST_TIP",
  POST_REPLY = "POST_REPLY",
  POST_VIEW = "POST_VIEW",
  POST_REPOST = "POST_REPOST",
  POST_QUOTE_REPOST = "POST_QUOTE_REPOST",
  POST_UPVOTE = "POST_UPVOTE",
  REACTION_LIKE = "REACTION_LIKE",
  REACTION_LAUGH = "REACTION_LAUGH",
  REACTION_LOVE = "REACTION_LOVE",
  REACTION_DISLIKE = "REACTION_DISLIKE",
  REACTION_ANGRY = "REACTION_ANGRY",
  REACTION_ASTONISHED = "REACTION_ASTONISHED",
  REACTION_SAD = "REACTION_SAD",
  POLL_RESPONSE = "POLL_RESPONSE",
  ADDED_TO_LIST = "ADDED_TO_LIST",
  NEW_DIRECT_PAID_MESSAGE = "NEW_DIRECT_PAID_MESSAGE",
  WHALE_POST_VIEW = "WHALE_POST_VIEW",
  POST_VIEW_THRESHOLD = "POST_VIEW_THRESHOLD",
  COIN_PURCHASE_PLACED = "COIN_PURCHASE_PLACED",
  COIN_SALE_PLACED = "COIN_SALE_PLACED",
  COIN_PURCHASE_FILLED = "COIN_PURCHASE_FILLED",
  COIN_SALE_FILLED = "COIN_SALE_FILLED",
  COIN_TRADING_FEE = "COIN_TRADING_FEE",
  COIN_LOCKUP_YIELD = "COIN_LOCKUP_YIELD",
  NEW_GROUP_PAID_MESSAGE = "NEW_GROUP_PAID_MESSAGE",
  NEW_DIRECT_UNPAID_MESSAGE = "NEW_DIRECT_UNPAID_MESSAGE",
  NEW_GROUP_UNPAID_MESSAGE = "NEW_GROUP_UNPAID_MESSAGE",
  NEW_DIRECT_PAID_MESSAGE_REPLY = "NEW_DIRECT_PAID_MESSAGE_REPLY",
  NEW_GROUP_PAID_MESSAGE_REPLY = "NEW_GROUP_PAID_MESSAGE_REPLY",
  NEW_DIRECT_UNPAID_MESSAGE_REPLY = "NEW_DIRECT_UNPAID_MESSAGE_REPLY",
  NEW_GROUP_UNPAID_MESSAGE_REPLY = "NEW_GROUP_UNPAID_MESSAGE_REPLY",
  ADDED_TO_GROUP_CHAT = "ADDED_TO_GROUP_CHAT",
  HIGH_VALUE_JOINING_REWARD = "HIGH_VALUE_JOINING_REWARD",
  REFERRAL_COIN_TRADING_FEE = "REFERRAL_COIN_TRADING_FEE",
  REFERRAL_EARNING = "REFERRAL_EARNING",
  PAID_MESSAGE_REDEMPTION = "PAID_MESSAGE_REDEMPTION",
  BOUNTY_REWARD_CLAIMED = "BOUNTY_REWARD_CLAIMED",
  REFERRAL_JOINED_FOCUS = "REFERRAL_JOINED_FOCUS",
  FOLLOWEE_NEW_POST = "FOLLOWEE_NEW_POST",
  SUBSCRIBEE_NEW_POST = "SUBSCRIBEE_NEW_POST",
}

export enum ReferralNotificationSubcategory {
  BOUNTY_REWARD_CLAIMED = "BOUNTY_REWARD_CLAIMED",
  NEW_SUBSCRIPTION = "NEW_SUBSCRIPTION",
  UNLOCKABLE_CONTENT = "UNLOCKABLE_CONTENT",
  COIN_TRADING_FEE = "COIN_TRADING_FEE",
  POST_TIP = "POST_TIP",
  NEW_DIRECT_PAID_MESSAGE = "NEW_DIRECT_PAID_MESSAGE",
  PAID_MESSAGE_REDEMPTION = "PAID_MESSAGE_REDEMPTION",
  COIN_PURCHASE_PLACED = "COIN_PURCHASE_PLACED",
  COIN_SALE_PLACED = "COIN_SALE_PLACED",
  COIN_PURCHASE_FILLED = "COIN_PURCHASE_FILLED",
  COIN_SALE_FILLED = "COIN_SALE_FILLED",
}

export const NotificationCategoryToSubCategories = {
  [NotificationCategory.EARNINGS]: [
    NotificationSubCategory.REFERRAL,
    NotificationSubCategory.COIN_PURCHASE,
    NotificationSubCategory.COIN_SALE,
    NotificationSubCategory.COIN_LOCKUP_YIELD,
    NotificationSubCategory.RECEIVED_DESO,
    NotificationSubCategory.RECEIVED_FOCUS,
    NotificationSubCategory.RECEIVED_DUSDC,
    NotificationSubCategory.RECEIVED_POST_TO_EARN,
    NotificationSubCategory.COIN_PURCHASE_PLACED,
    NotificationSubCategory.COIN_SALE_PLACED,
    NotificationSubCategory.COIN_PURCHASE_FILLED,
    NotificationSubCategory.COIN_SALE_FILLED,
    NotificationSubCategory.COIN_TRADING_FEE,
    NotificationSubCategory.HIGH_VALUE_JOINING_REWARD,
    NotificationSubCategory.REFERRAL_COIN_TRADING_FEE,
    NotificationSubCategory.REFERRAL_EARNING,
    NotificationSubCategory.BOUNTY_REWARD_CLAIMED,
  ],
  [NotificationCategory.MESSAGES]: [
    NotificationSubCategory.PAID_MESSAGE,
    NotificationSubCategory.UNPAID_MESSAGE,
    NotificationSubCategory.ADDED_GROUP_CHAT,
    NotificationSubCategory.NEW_GROUP_PAID_MESSAGE,
    NotificationSubCategory.NEW_DIRECT_UNPAID_MESSAGE,
    NotificationSubCategory.NEW_GROUP_UNPAID_MESSAGE,
    NotificationSubCategory.NEW_DIRECT_PAID_MESSAGE_REPLY,
    NotificationSubCategory.NEW_GROUP_PAID_MESSAGE_REPLY,
    NotificationSubCategory.NEW_DIRECT_UNPAID_MESSAGE_REPLY,
    NotificationSubCategory.NEW_GROUP_UNPAID_MESSAGE_REPLY,
    NotificationSubCategory.ADDED_TO_GROUP_CHAT,
  ],
  [NotificationCategory.PROMOTION]: [
    NotificationSubCategory.PROMOTION_OFFER,
    NotificationSubCategory.PROMOTION_PERFORMANCE,
  ],
  [NotificationCategory.SOCIAL]: [
    NotificationSubCategory.FOLLOW,
    NotificationSubCategory.MENTION,
    NotificationSubCategory.POST_TIP,
    NotificationSubCategory.POST_REPLY,
    NotificationSubCategory.POST_VIEW,
    NotificationSubCategory.POST_REPOST,
    NotificationSubCategory.POST_QUOTE_REPOST,
    NotificationSubCategory.POST_UPVOTE,
    NotificationSubCategory.REACTION_LIKE,
    NotificationSubCategory.REACTION_LAUGH,
    NotificationSubCategory.REACTION_LOVE,
    NotificationSubCategory.REACTION_DISLIKE,
    NotificationSubCategory.REACTION_ANGRY,
    NotificationSubCategory.REACTION_ASTONISHED,
    NotificationSubCategory.REACTION_SAD,
    NotificationSubCategory.REFERRAL_JOINED_FOCUS,
  ],
  [NotificationCategory.POST]: [NotificationSubCategory.UNLOCKABLE_CONTENT],
};

export const NotificationSubCategoryLabels = {
  [NotificationSubCategory.REFERRAL]: "Referral",
  [NotificationSubCategory.PAID_MESSAGE]: "Paid Message",
  [NotificationSubCategory.PAID_MESSAGE_REDEMPTION]: "Paid Message",
  [NotificationSubCategory.NEW_SUBSCRIPTION]: "New Subscription",
  [NotificationSubCategory.UNLOCKABLE_CONTENT]: "Unlockable Content",
  [NotificationSubCategory.COIN_PURCHASE]: "Coin Purchase",
  [NotificationSubCategory.COIN_SALE]: "Coin Sale",
  [NotificationSubCategory.COIN_LOCKUP_YIELD]: "Coin Lockup Yield",
  [NotificationSubCategory.RECEIVED_DESO]: "Received DESO",
  [NotificationSubCategory.RECEIVED_FOCUS]: "Received FOCUS",
  [NotificationSubCategory.RECEIVED_DUSDC]: "Received DUSDC",
  [NotificationSubCategory.RECEIVED_POST_TO_EARN]: "Received Post To Earn",
  [NotificationSubCategory.UNPAID_MESSAGE]: "Unpaid Message",
  [NotificationSubCategory.ADDED_GROUP_CHAT]: "Added Group Chat",
  [NotificationSubCategory.PROMOTION_OFFER]: "Promotion Offer",
  [NotificationSubCategory.PROMOTION_PERFORMANCE]: "Promotion Performance",
  [NotificationSubCategory.FOLLOW]: "Follow",
  [NotificationSubCategory.MENTION]: "Mention",
  [NotificationSubCategory.POST_TIP]: "Post Tip",
  [NotificationSubCategory.POST_REPLY]: "Post Reply",
  [NotificationSubCategory.POST_VIEW]: "Post View",
  [NotificationSubCategory.POST_REPOST]: "Post Repost",
  [NotificationSubCategory.POST_QUOTE_REPOST]: "Post Quote Repost",
  [NotificationSubCategory.POST_UPVOTE]: "Post Upvote",
  [NotificationSubCategory.REACTION_LIKE]: "Reaction Like",
  [NotificationSubCategory.REACTION_LAUGH]: "Reaction Laugh",
  [NotificationSubCategory.REACTION_LOVE]: "Reaction Love",
  [NotificationSubCategory.REACTION_DISLIKE]: "Reaction Dislike",
  [NotificationSubCategory.REACTION_ANGRY]: "Reaction Angry",
  [NotificationSubCategory.REACTION_ASTONISHED]: "Reaction Astonished",
  [NotificationSubCategory.REACTION_SAD]: "Reaction Sad",
  [NotificationSubCategory.POLL_RESPONSE]: "Poll Response",
  [NotificationSubCategory.ADDED_TO_LIST]: "Added To List",
  [NotificationSubCategory.NEW_DIRECT_PAID_MESSAGE]: "New Direct Paid Message",
  [NotificationSubCategory.WHALE_POST_VIEW]: "Whale Post View",
  [NotificationSubCategory.POST_VIEW_THRESHOLD]: "Post View Threshold",
  [NotificationSubCategory.COIN_PURCHASE_PLACED]: "Coin Purchase Placed",
  [NotificationSubCategory.COIN_SALE_PLACED]: "Coin Sale Placed",
  [NotificationSubCategory.COIN_PURCHASE_FILLED]: "Coin Purchase Filled",
  [NotificationSubCategory.COIN_SALE_FILLED]: "Coin Sale Filled",
  [NotificationSubCategory.COIN_TRADING_FEE]: "Coin Trading Fee",
  [NotificationSubCategory.REFERRAL_EARNING]: "Referral Earning",
  [NotificationSubCategory.NEW_GROUP_PAID_MESSAGE]: "New Group Paid Message",
  [NotificationSubCategory.NEW_DIRECT_UNPAID_MESSAGE]:
    "New Direct Unpaid Message",
  [NotificationSubCategory.NEW_GROUP_UNPAID_MESSAGE]:
    "New Group Unpaid Message",
  [NotificationSubCategory.NEW_DIRECT_PAID_MESSAGE_REPLY]:
    "New Direct Paid Message Reply",
  [NotificationSubCategory.NEW_GROUP_PAID_MESSAGE_REPLY]:
    "New Group Paid Message Reply",
  [NotificationSubCategory.NEW_DIRECT_UNPAID_MESSAGE_REPLY]:
    "New Direct Unpaid Message Reply",
  [NotificationSubCategory.NEW_GROUP_UNPAID_MESSAGE_REPLY]:
    "New Group Unpaid Message Reply",
  [NotificationSubCategory.ADDED_TO_GROUP_CHAT]: "Added To Group Chat",
  [NotificationSubCategory.HIGH_VALUE_JOINING_REWARD]: "Joining Reward",
  [NotificationSubCategory.REFERRAL_COIN_TRADING_FEE]:
    "Referral Coin Trading Fee",
  [NotificationSubCategory.BOUNTY_REWARD_CLAIMED]: "Bounty Reward Claimed",
  [NotificationSubCategory.REFERRAL_JOINED_FOCUS]: "Referral Joined Focus",
  [NotificationSubCategory.FOLLOWEE_NEW_POST]: "Followee New Post",
  [NotificationSubCategory.SUBSCRIBEE_NEW_POST]: "Subscribee New Post",
};

export enum NotificationTransmissionType {
  PUSH = "PUSH",
  EMAIL = "EMAIL",
  DAILY_DIGEST = "DAILY_DIGEST",
  WEEKLY_DIGEST = "WEEKLY_DIGEST",
}

export enum NotificationStatus {
  QUEUED = "QUEUED",
  PROCESSED = "PROCESSED",
  SKIPPED = "SKIPPED",
  READ = "READ",
}

export const NotificationStatusLabels = {
  [NotificationStatus.QUEUED]: "Queued",
  [NotificationStatus.PROCESSED]: "Processed",
  [NotificationStatus.SKIPPED]: "Skipped",
  [NotificationStatus.READ]: "Read",
};

export enum NotificationOrderBy {
  NEWEST = "NEWEST",
  OLDEST = "OLDEST",
  HI_VALUE = "HI_VALUE",
  LO_VALUE = "LO_VALUE",
}

export const NotificationCategoryLabel = {
  [NotificationCategory.EARNINGS]: "Earnings",
  [NotificationCategory.MESSAGES]: "Message",
  [NotificationCategory.PROMOTION]: "Promotion",
  [NotificationCategory.SOCIAL]: "Social",
  [NotificationCategory.POST]: "Post",
  [NotificationCategory.MONEY]: "Money",
};
